type UserStatusProps = {
  status: string;
  className?: string;
};

export const UserStatus: React.FC<UserStatusProps> = ({ status, className = '' }) => {
  const baseStyle = 'inline-block px-3 py-1 rounded-full text-sm font-medium';

  const statusStyles: Record<string, string> = {
    active: 'bg-green-100 text-green-800',
    disabled: 'bg-red-100 text-gray-800',
    invited: 'bg-yellow-100 text-yellow-800',
    banned: 'bg-black text-white',
  };

  const statusKey = status.toLowerCase();
  const statusClass = statusStyles[statusKey] || 'bg-gray-200 text-gray-900';

  const nameCasedStatus = status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();

  return <span className={`${baseStyle} ${statusClass} ${className}`}>{nameCasedStatus}</span>;
};
